"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomElementMode = exports.CustomElementType = exports.RequestStatus = exports.OptionsType = exports.OccassionType = exports.ReservationStatus = void 0;
const customElements_1 = require("./customElements");
Object.defineProperty(exports, "CustomElementType", { enumerable: true, get: function () { return customElements_1.CustomElementType; } });
Object.defineProperty(exports, "CustomElementMode", { enumerable: true, get: function () { return customElements_1.CustomElementMode; } });
var ReservationStatus;
(function (ReservationStatus) {
    ReservationStatus["SUCCESS"] = "success";
    ReservationStatus["FAILED"] = "failed";
    ReservationStatus["POSITIVE"] = "positive";
    ReservationStatus["PENDING"] = "pending";
    ReservationStatus["NEGATIVE"] = "negative";
})(ReservationStatus = exports.ReservationStatus || (exports.ReservationStatus = {}));
var OccassionType;
(function (OccassionType) {
    OccassionType[OccassionType["DEFAULT"] = 0] = "DEFAULT";
    OccassionType[OccassionType["FOOD"] = 1] = "FOOD";
    OccassionType[OccassionType["DRINKS_ONLY"] = 2] = "DRINKS_ONLY";
    OccassionType[OccassionType["TICKET"] = 3] = "TICKET";
    OccassionType[OccassionType["BREAKFAST"] = 4] = "BREAKFAST";
    OccassionType[OccassionType["LUNCH"] = 5] = "LUNCH";
    OccassionType[OccassionType["BRUNCH"] = 6] = "BRUNCH";
    OccassionType[OccassionType["DINNER"] = 7] = "DINNER";
    OccassionType[OccassionType["LIVE_MUSIC"] = 8] = "LIVE_MUSIC";
    OccassionType[OccassionType["LOUNGE"] = 9] = "LOUNGE";
    OccassionType[OccassionType["COFFEE"] = 10] = "COFFEE";
})(OccassionType = exports.OccassionType || (exports.OccassionType = {}));
var OptionsType;
(function (OptionsType) {
    OptionsType["WEBSITE"] = "WEBSITE";
    OptionsType["WAITER"] = "WAITER";
    OptionsType["PHONE"] = "PHONE";
})(OptionsType = exports.OptionsType || (exports.OptionsType = {}));
var RequestStatus;
(function (RequestStatus) {
    RequestStatus["PENDING"] = "pending";
    RequestStatus["WAITING"] = "waiting";
    RequestStatus["SUCCESS"] = "success";
    RequestStatus["FAILED"] = "failed";
    RequestStatus["CANCELED"] = "canceled";
})(RequestStatus = exports.RequestStatus || (exports.RequestStatus = {}));
